import { dropdownTriggerClassname } from "app/components/Dropdown";
import { FlagIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import CommonPrioritySelection from "app/containers/Features/components/CommonPrioritySelection";
import { PriorityFilterEnum } from "app/types";
import clsx from "clsx";
import React, { useMemo } from "react";
import { getPriorityByIds } from "../../../../helpers";

interface CustomProps {
  value: PriorityFilterEnum;
  onUpdate: (id: PriorityFilterEnum) => void;
}

const Priority: React.FC<CustomProps> = ({ value, onUpdate }) => {
  const selectedPriority = useMemo(() => {
    return getPriorityByIds(value);
  }, [value]);

  const handleSelect = (value) => {
    onUpdate(value);
  };

  return (
    <div className=" relative w-full ">
      <CommonPrioritySelection
        trigger={
          <button
            className={clsx(
              "flex items-center hover:border hover:border-gray-300 p-[4px] rounded-[2px] min-w-[100px] cursor-pointer h-full w-full  ",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip
              text="Set priority"
              className="flex items-center "
              position="left"
            >
              {selectedPriority ? (
                <div className="flex items-center gap-2 w-full">
                  <FlagIcon size={16} color={selectedPriority?.color} />
                  <span className="text-sm font-normal text-black">
                    {selectedPriority?.label}
                  </span>
                </div>
              ) : (
                "-"
              )}
            </CustomTooltip>
          </button>
        }
        value={value}
        setValue={(val) => {
          handleSelect(val);
        }}
        align="start"
        isShowArrow
      />
    </div>
  );
};

export default Priority;
